import { useState } from "react";
import { withNamespaces } from "react-i18next";
import { Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Row } from "reactstrap";
import Widgets from "./components/Widgets";
import AccuracyAssessment from "./components/AccuracyAssessment";
import MonthlyScreenedEntites from "./components/MonthlyScreenedEntites";
import RisksChart from "./components/RisksChart";
import TasksChart from "./components/TasksChart";
import FilteringComponent from "./components/FilteringComponent";
import AIFalsePositives from "./components/AIFalsePositives";
import Categories from "./components/Categories";
import LatestTruePositives from "./components/LatestTruePositives";
import RecentActivities from "./components/RecentActivities";
import RisksHeatmap from "./components/RisksHeatmap";
import CreditUsage from "./components/CreditUsage";

import "./style.scss";

const Dashboard = ({
    t
}) => {
    const [filters, setFilters] = useState({});
    const [ moreActionsDropDownOpen, setMoreActionsDropDownOpen ] = useState(false);

    const toggleMoreActionsDropDown = () => setMoreActionsDropDownOpen(!moreActionsDropDownOpen)

    return (
        <div className="compliance-dashboard">
            <Row className="g-4 align-items-stretch ">
                <Col sm="12">
                    <div
                        style={{
                            position: 'sticky',
                            top: '74px',
                            zIndex: 10
                        }}
                        className="d-flex justify-content-end align-items-center mb-3"
                    >
                        <div className="d-flex justify-content-end align-items-center bg-white">
                            <div className="d-flex">
                                <FilteringComponent
                                    onChange={(newFilters) => {
                                        setFilters({
                                            ...filters,
                                            ...newFilters
                                        });
                                    }}
                                />
                            </div>

                            <div className='d-flex'>
                                <Dropdown
                                    isOpen={moreActionsDropDownOpen}
                                    toggle={toggleMoreActionsDropDown}
                                >
                                    <DropdownToggle
                                        caret
                                        variant="outline-secondary"
                                        outline
                                    >
                                        {t('Actions')}
                                    </DropdownToggle>
                                    <DropdownMenu className='dropdown-menu-end'>
                                        <DropdownItem
                                            onClick={(e) => {
                                                e.preventDefault()
                                                e.stopPropagation()
                                            }}
                                        >
                                            <div>
                                                <i className="ri-file-excel-2-line align-middle me-2" />
                                                {t("Export Excel")}
                                            </div>
                                        </DropdownItem>

                                        <DropdownItem
                                            onClick={(e) => {
                                                e.preventDefault()
                                                e.stopPropagation()
                                            }}
                                        >
                                            <div>
                                                <i className="ri-file-pdf-line align-middle me-2" />
                                                {t("Export PDF")}
                                            </div>
                                        </DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                </Col>

                <Col sm="12">
                    <Row>
                        <Col sm="12" md="6" lg="4" xl="3">
                            <CreditUsage />
                        </Col>
                    </Row>
                </Col>

                <Col sm="12">
                    <Widgets
                        filters={filters}
                    />
                </Col>

                <Col sm="12" md="6" lg="6" xl="6">
                    <AIFalsePositives 
                        filters={filters}
                    />
                </Col>

                <Col sm="12" md="6" lg="6" xl="3">
                    <AccuracyAssessment 
                        filters={filters}
                    />
                </Col>

                <Col sm="12" md="12" lg="12" xl="3">
                    <Categories 
                        filters={filters}
                    />
                </Col>

                <Col sm="12" md="7" lg="7">
                    <MonthlyScreenedEntites 
                        filters={filters}
                    />
                </Col>

                <Col sm="12" md="5" lg="5">
                    <LatestTruePositives 
                        fitlers={filters}
                    />
                </Col>

                <Col sm="12" md="4" lg="4">
                    <RisksChart
                        filters={filters}
                    />
                </Col>

                <Col sm="12" md="4" lg="4">
                    <TasksChart
                        filters={filters}
                    />
                </Col>

                <Col sm="12" md="4" lg="4">
                    <RecentActivities
                        filters={filters}
                    />
                </Col>

                <Col sm="12" md="12" lg="12">
                    <RisksHeatmap 
                        filters={filters}
                    />
                </Col>
            </Row>
        </div>
    )
}

export default withNamespaces()(
    Dashboard
);